

const formatGrowthbookExperimentAnalytics = (experimentId: string, variationId: string | number) => ({
    experimentId,
    variationId,
});

export default formatGrowthbookExperimentAnalytics;
